export interface IVimeoHtmlParams {
  videoId: string
  // Privacy hash for unlisted videos. Must lead the query string (`?h=<hash>&...`)
  // or Vimeo answers 403.
  hash?: string
  startSeconds: number
  borderRadiusPx: number
}

export function buildVimeoHtml(params: IVimeoHtmlParams): string {
  const { videoId, hash, startSeconds, borderRadiusPx } = params
  const query = [
    hash ? `h=${encodeURIComponent(hash)}` : null,
    'api=1',
    'autoplay=0',
    'playsinline=1',
    'controls=1',
    'fullscreen=1',
    'dnt=1',
    `start=${startSeconds}`,
  ]
    .filter(Boolean)
    .join('&')
  return `<!DOCTYPE html>
<html>
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
    <style>
      html, body { margin: 0; padding: 0; background: transparent; height: 100%; }
      #container { position: absolute; inset: 0; }
      iframe { width: 100%; height: 100%; border: 0; border-radius: ${borderRadiusPx}px; }
    </style>
    <script src="https://player.vimeo.com/api/player.js"></script>
  </head>
  <body>
    <div id="container">
      <iframe id="vimeo-iframe"
        src="https://player.vimeo.com/video/${videoId}?${query}"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        title="vimeo-player"
      ></iframe>
    </div>
    <script>
      (function() {
        var iframe = document.getElementById('vimeo-iframe');
        function post(evt, data) {
          try { window.ReactNativeWebView.postMessage(JSON.stringify({ event: evt, data: data || {} })); } catch(e) {}
        }
        function setup() {
          if (!window.Vimeo || !iframe) { return false; }
          try {
            var player = new Vimeo.Player(iframe);
            player.on('timeupdate', function(data) { post('timeupdate', data); });
            player.on('play', function() { post('play', {}); });
            player.on('pause', function() { post('pause', {}); });
            document.addEventListener('fullscreenchange', function(){
              var isFs = !!document.fullscreenElement; post(isFs ? 'enterpictureinpicture' : 'exitpictureinpicture', {});
            });
            return true;
          } catch (e) {
            return false;
          }
        }
        var ok = setup();
        if (!ok) {
          var attempts = 0;
          var id = setInterval(function(){
            attempts++;
            if (setup()) { clearInterval(id); }
            if (attempts > 200) { clearInterval(id); }
          }, 250);
        }
      })();
    </script>
  </body>
</html>`
}
